import { timeZoneAbbrMap } from '@/utils/timeZoneAbbrMap';

export function formatTimestampWithBrowserTimezone(
  utcString: string,
  recordTimezone?: string
): string {
  if (!utcString) return '';

  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(utcString);

  // Helper function for formatting in any timezone
  const formatInZone = (tz: string) => {
    const formatted = date
      .toLocaleString('en-GB', {
        timeZone: tz,
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
      .replace(',', ' at');

    const abbr = timeZoneAbbrMap[tz] || getFallbackAbbreviation(date, tz);
    return { formatted, abbr };
  };

  const browser = formatInZone(browserTimezone);

  // 🧩 If record timezone exists, show "Performed as ..."
  if (recordTimezone) {
    const record = formatInZone(recordTimezone);
    return `${browser.formatted} (${browser.abbr}) — Performed at ${record.formatted.split(' at ')[1]} (${record.abbr})`;
  }

  // 🧩 If no record timezone, fallback to old single-time display
  return `${browser.formatted} (${browser.abbr})`;
}

function getFallbackAbbreviation(date: Date, timeZone: string): string {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    }).formatToParts(date);
    const zoneName = parts.find((part) => part.type === 'timeZoneName');
    if (zoneName?.value?.startsWith('GMT')) {
      return ''; // or return 'UTC'
    }
    return zoneName?.value || '';
  } catch {
    return '';
  }
}
